/** The secondary consent that decides whose records may be connected. */
export const HEALTH_RECORDS_ACCESS_ITEM_ID = 'health-records-access'

const ANSWER_KEYS = [
  HEALTH_RECORDS_ACCESS_ITEM_ID,
  `${HEALTH_RECORDS_ACCESS_ITEM_ID}:SELF`,
  `${HEALTH_RECORDS_ACCESS_ITEM_ID}:DEPENDENT`,
]

/**
 * True when the secondary answers accept Health Records Access for the user or the patient.
 * A Sibling's answer does not count: nobody connects a Sibling's records.
 */
export function acceptsHealthRecordsAccess(answers: Record<string, boolean | undefined>): boolean {
  return ANSWER_KEYS.some((key) => answers[key] === true)
}
